import Axios from "../config/config";

//NOTIFICATION APIS 

export const ADD_NOTIFICATION = async (body) => {
    try {
        const response = await Axios.post('add-notification/', body);
        return response;
    } catch (error) {
        console.error(error);
    }
};


export const EDIT_NOTIFICATION = async (body) => {
    try {
        const response = await Axios.post('edit-notification/', body);
        return response;
    } catch (error) {
        console.error(error);
    }
};
export const VIEW_NOTIFICATION = async (body) => {
    try {
        const response = await Axios.post('view-notification/', body);
        return response;
    } catch (error) {
        console.error(error);
    }
};

export const LIST_NOTIFICATION = async (body) => {
    try {
        const response = await Axios.post('list-notification/', body);
        return response;
    } catch (error) {
        console.error(error);
    }
};
